module.exports = __webpack_public_path__ + "img/duplicate.604a44f9.svg";